export default __webpack_public_path__ + "static/tech-stack-dubai-098d59d5272c9fd03c5ed08bd645b10e.webp";